<template>
    <div id="warranty_list">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div class="bg-white data-table p-0" v-if="warrantyVal != undefined">
            <vue-good-table
                ref="listWarrantyTable"
                mode="remote"
                title="Warranty"
                @on-page-change="onPageChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                @on-sort-change="onSortChange"
                :totalRows="totalRecords"
                :columns="columns"
                :rows="rows"
                :pagination-options="{
                    enabled: true,
                    position: 'both',
                    perPage: perPage,
                    perPageDropdown:dropDownPerPage,
                    dropdownAllowAll: false,
                }"
                :select-options="{
                enabled: deleteWarranty,
                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
                }"
                :search-options="{
                enabled: false,
                }">
                <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                    <div :key="key">
                        <div v-if="props.column.field == 'action'">
                            <router-link v-if="updateWarranty" title="Edit Warranty" class="fp-edit mr-3" v-bind:to="{name: 'WarrantyEdit',params:{id:props.row.id}}"></router-link>
                            <router-link class="fp-receive-order mr-3" v-if="viewWarranty" title="Add Asset" v-bind:to="{name: 'AssetWarrantyList',params:{id:props.row.id}}"></router-link>
                        </div>
                        <div v-else-if="props.column.field == 'code'">
                            <router-link class="color-blue" v-if="viewWarranty" title="View Warranty" v-bind:to="{name: 'WarrantyView',params:{id:props.row.id}}">
                                {{ props.row.code }}
                            </router-link>
                        </div>
                        <div v-else>
                            {{props.formattedRow[props.column.field]}}
                        </div>
                    </div>
                </template>
                <div slot="selected-row-actions">
                    <button v-if="deleteWarranty" id="deleteWarrantyBtn" v-on:click.prevent="WarrantyDelete" class="btn btn-danger">Delete</button>
                </div>
            </vue-good-table>
        </div>
        <div id="page-content-wrapper" class="admin-content-area" v-else>
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Warranty List</div>
                    <div class="btn-groups text-right">
                        <!-- not in use
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="openModal()" >
                            <i class="fp-import"></i> Import
                        </a> -->
                        <router-link v-if="addWarranty" class="btn btn-primary" v-bind:to="{name: 'WarrantyCreate'}"> <i class="fp-add"> </i> Add</router-link>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content warranty-list">
                        <data-table-filter-config :moduleName="'WarrantyList'" ref="filterWarranty" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'WarrantyList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                    ref="listWarrantyTable"
                                    mode="remote"
                                    title="Warranty"
                                    @on-page-change="onPageChange"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: deleteWarranty,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <router-link v-if="updateWarranty" title="Edit Warranty" class="fp-edit mr-3" v-bind:to="{name: 'WarrantyEdit',params:{id:props.row.id}}">
                                                </router-link>
                                                <router-link class="fp-receive-order mr-3" v-if="viewWarranty" title="Add Asset" v-bind:to="{name: 'AssetWarrantyList',params:{id:props.row.id}}"></router-link>
                                            </div>
                                            <div v-else-if="props.column.field == 'code'">
                                                <router-link class="color-blue" v-if="viewWarranty" title="View Warranty" v-bind:to="{name: 'WarrantyView',params:{id:props.row.id}}">
                                                    {{ props.row.code }}
                                                </router-link>
                                            </div>
                                            <div v-else>
                                                {{ props.formattedRow[props.column.field] }}
                                            </div>
                                        </div>
                                    </template>
                                    <div slot="selected-row-actions">
                                        <button v-if="deleteWarranty" id="deleteWarrantyBtn" v-on:click.prevent="WarrantyDelete" class="btn btn-danger">Delete</button>
                                        <button id="warrantyLimitationBtn" v-on:click.prevent="limitationList" class="btn btn-primary">Limitation</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                        <div class="modal fade warranty-modal" id="warranty-modal" ref="warranty-modal" data-backdrop="static" data-keyboard="false" aria-labelledby="warranty-modal" aria-hidden="true">
                                    <div class="modal-dialog" role="document">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h5 class="modal-title">Select File</h5>
                                            </div>
                                            <div class="modal-body">
                                                <form id="importFile" class="addinspectionForm">
                                                    <div class="form-row">
                                                        <div class="col form-group">
                                                            <label class="control-label require mb-2" for="name">File:</label><br/>
                                                            <input id="warrantyFile" type="file" @change="onFileChanged">
                                                            <div class="field-error">{{import_error}}</div>
                                                        </div>
                                                    </div>
                                                </form>

                                                <div class="modal-footer">
                                                    <button class="btn btn-tertiary" id="cancelButton" data-dismiss="modal"> <i class="fp-close"> </i>Cancel</button>
                                                    <button class="btn btn-primary" id="importButton" v-on:click="importWarranty()"> <i class="fp-import"> </i> Import</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "WarrantyList",
        metaInfo() {
            return {title: "Warranty List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        props: {
            warrantyVal: {
                type: String,
                required: false,
                default:undefined
            }
        },
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            velocity_env:process.env.NODE_ENV,
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: '#Warranty',
                    field: 'code',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Description',
                    field: 'description',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Description", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Type',
                    field: 'warranty_type_id',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Warranty Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Starting Point',
                    field: 'starting_point_value',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Starting Point Value", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [{value:'E',text:'Effective (E)'},
                            {value:'I',text:'In Service Date (I)'},
                            {value:'P',text:'Purchased (P)'}],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Period',
                    field: 'period',
                    filterable: true,
                    fpFieldType:"integer",
                    type : 'number',
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Period", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            deleteWarranty: false,
            updateWarranty: false,
            viewWarranty: false,
            addWarranty: false,
            addClaim:false,
            loading:false,
            selectedFile:"",
            import_error:"",
            duplicatePolicy:[]
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                      if(self.velocity_env == 'velev' || self.velocity_env == 'velev_test'){
                        if (permissions[i].name == 'ev_list_warranty') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'ev_view_warranty') {
                            self.viewWarranty = true;
                        }
                        if (permissions[i].name == 'ev_add_warranty') {
                            self.addWarranty = true;
                            self.updateWarranty = true;
                        }
                        if (permissions[i].name == 'ev_delete_warranty') {
                            self.deleteWarranty = true;
                        }
                        if (permissions[i].name == 'ev_add_claim') {
                            self.addClaim = true;
                        }
                      }else{
                        if (permissions[i].name == 'list_warranty') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'view_warranty') {
                            self.viewWarranty = true;
                        }
                        if (permissions[i].name == 'add_warranty') {
                            self.addWarranty = true;
                            self.updateWarranty = true;
                        }
                        if (permissions[i].name == 'delete_warranty') {
                            self.deleteWarranty = true;
                        }
                        if (permissions[i].name == 'add_claim') {
                            self.addClaim = true;
                        }
                      }
                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;
            self.startPointValue = self.startingPointArr;
            //self.loadList();
            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listWarrantyTable.unselectAllInternal();
            },

            WarrantyCreatePage(){
                var self = this;
                self.$router.push("/warranty/create");
            },

            onFileChanged(event) {
                const file = event.target.files[0];
                var self = this;
                self.selectedFile = file;
                self.import_error = '';
            },

            openModal: function(){
                var self = this;
                self.selectedFile = "";
                self.duplicate = [];
                $("#warrantyFile").val('');
                self.import_error = '';
                $('#warranty-modal').modal('show');
            },

            importWarranty: function() {

              var self = this;
                self.import_error = "";
                if(self.selectedFile == "" || self.selectedFile == null){
                    self.import_error = "Please Select Excel File.";
                    return;
                }
                var formData = new FormData();
                formData.append('myFile', self.selectedFile);

                self.loading = true;
                $('#importButton').text('Fetching...');
                $('#importButton').prop('disabled',true);
                $('#cancelButton').prop('disabled',true);

                $.ajax({
                    url: process.env.ROOT_API + "/warranty/import",
                    type: "POST",
                    data: formData,
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        $('#importButton').text('Import');
                        $('#importButton').prop('disabled',false);
                        $('#cancelButton').prop('disabled',false);
                        self.import_error = '';
                        if (data.code == 201) {
                            self.import_error = data.message;
                            return;
                        }
                        if (data.status == "success") {

                            if ( Object.keys(data.duplicate).length > 0){

                                self.duplicateWarranty = data.duplicate;
                                if(data.content != false){
                                    self.$swal('',data.content+" Records imported",'success');
                                }
                                self.import_error = "";
                                $('#warranty-modal').modal('hide');
                            }else{
                                if(data.content != false){
                                    self.$swal('',data.content+" Records imported",'success');
                                }
                                self.import_error = "";
                                $('#warranty-modal').modal('hide');
                            }
                            self.loadList();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        $('#importButton').text('Import');
                        $('#importButton').prop('disabled',false);
                        $('#cancelButton').prop('disabled',false);
                        self.generateStatusCodeMessage(jqXHR,true,'warranty-import-error')
                    }
                });

            },

            loadList() {
                var self = this;
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    // messageData: self.message,
                    sort: self.serverParams.sort,
                    // exportFiltered: self.exportFilteredFlag
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/warranty/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");

                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            WarrantyDelete() {
                var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete this Warranty?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                      var data = this.$refs['listWarrantyTable'].selectedRows;
                      var use = [];
                      for (var i = 0; i < data.length; i++) {
                          use.push(this.$refs['listWarrantyTable'].selectedRows[i].id)
                      }
                      console.log("list of IDS =", use);
                      self.loading = true;
                      $("#deleteWarrantyBtn").val("Deleting ...");
                      $.ajax({
                          url: process.env.ROOT_API + "/warranty/delete",
                          type: "POST",
                          data: 'ids=' + use,
                          headers: this.ajxHeaders,
                          dataType: 'json',
                          success: function (data) {
                              self.loading = false;
                              setTimeout(function () {
                              $(".alert-success").removeClass("show");
                                  $(".alert-success").addClass("hide");
                              }, 10000);
                              setTimeout(function () {
                                  $("#deleteWarrantyBtn").val("Delete");
                              }, 10000);
                              self.rows = data.content.row;
                              if (data.code == '200') {
                                  self.rows = data.content.row;
                                  self.totalRecords = data.content.totalRecords;
                                  self.loadList();
                              }
                          },
                          error: function (jqXHR, exception) {
                              self.loading = false;
                              if (jqXHR.status == 0) {
                                  self.error = "Remote server cannot be reached";
                              } else {
                                  //redirect to login page if user not authenticated
                                  if (jqXHR.status == 401) {
                                      //clear previous data
                                      localStorage.removeItem('user_obj');
                                      localStorage.removeItem('tkn');
                                      self.$router.push("/");
                                  }
                                self.error = jqXHR.responseJSON.message;
                              }
                          }
                      });

                    } else {
                      console.log("no");
                    }
                });
            },
            limitationList: function(){
                var self = this;

                var data = this.$refs['listWarrantyTable'].selectedRows;
                var self = this;
                var use = [];

                if(data.length > 1){

                    self.$swal('','Please select atmost one record','info');

                }else{

                   self.$router.push({name: 'WarrantyLimitation', params: {id: data[0].id}});

                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/WarrantyList.vue